/*
 * @Description:
 * @Date: 2020-07-18 16:13:15
 */

import { BI } from '@/api/ajax';
import combination from './combination';
import { percentage } from '@/tools/index';
import {
  createLineSeries,
  createMapSeries1
} from '../components/Echarts/echartOption';
import {
  getRadioOptions,
  getMultipleChoiceOptions,
  getGradeOptions
} from '../components/Echarts/random';
import { axisFormatter, dealTips } from '../tools/index';

// 1单选  2多选  3单项投票  4单项填空 5多项填空 6打分题  7姓名手机邮箱-单选填空 8上传附件
// 9 pdf 10 word 11 excel 12 ppt 13 jpg/png 14时间-单选填空 15月度--按年月分开做两张报表 16定位
// TODO: 9 10 11 12 13没有UI
// TODO: 16没数据
const questionMap = {
  1: '单选题',
  2: '多选题',
  3: '文字投票题-单选',
  4: '填空题',
  5: '多项填空题',
  6: '打分题',
  7: '填空题',
  14: '时间题',
  15: '月度题',
  16: '定位题',
  20: '签名题'
};
const typeFuncs = {
  type1(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark, optionJson } = im;
    let finalData = im.finalData || {};
    let header = [
      { label: '选项', prop: 'd' },
      { label: '任务数（单）', prop: 'v' },
      { label: '百分比(%)', prop: 'b' }
    ];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    let keys = Object.keys(finalData);
    try {
      keys = JSON.parse(optionJson);
    } catch (error) {}
    keys.forEach(m => {
      xAxisData.push(m);
      series0data.push({
        value: finalData[m],
        name: m,
        b: finalData[m] + '单'
      });
      data.push({
        d: m,
        v: finalData[m],
        b: percentage(finalData[m], finalDataCount)
      });
    });
    return getRadioOptions({
      ix,
      remark,
      title,
      questionType: questionMap[type],
      isMustFill,
      header,
      data: data,
      finalDataCount,
      xAxisData,
      series0data: series0data
    });
  },
  type2(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark, optionJson } = im;
    let finalData = im.finalData || {};
    let header = [
      { label: '选项', prop: 'd' },
      { label: '任务数（单）', prop: 'v' },
      { label: '百分比(%)', prop: 'b' }
    ];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    let keys = Object.keys(finalData);
    try {
      keys = JSON.parse(optionJson);
    } catch (err) {
      console.error(err);
    }
    keys.forEach(m => {
      xAxisData.push(m);
      series0data.push({
        value: finalData[m],
        name: m,
        b: finalData[m] + '单'
      });
      data.push({
        d: m,
        v: finalData[m],
        b: percentage(finalData[m], finalDataCount)
      });
    });
    return getMultipleChoiceOptions({
      ix,
      title,
      remark,
      questionType: questionMap[type],
      isMustFill,
      header,
      data,
      finalDataCount,
      xAxisData,
      series0data
    });
  },
  type3(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark, optionJson } = im;
    let finalData = im.finalData || {};

    // let header = [
    //   { label: '选项', prop: 'd' },
    //   { label: '任务数（单）', prop: 'v' },
    //   { label: '百分比(%)', prop: 'b' }
    // ];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    let keys = Object.keys(finalData);
    try {
      keys = JSON.parse(optionJson);
    } catch (err) {
      console.error(err);
    }
    keys.forEach(m => {
      xAxisData.push(m);
      series0data.push({
        value: finalData[m],
        name: m,
        b: finalData[m] + '单'
      });
      data.push({
        d: m,
        v: finalData[m],
        b: percentage(finalData[m], finalDataCount)
      });
    });
    return {
      key: 'type3-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        echart: [
          {
            echartType: 'line',
            echartOption: {
              tooltip: {
                formatter: function(params) {
                  const { axisValue, value } = params[0] || params || {};
                  return dealTips(axisValue, value, '单');
                }
              },
              xAxis: {
                type: 'category',
                data: xAxisData,
                name: '选项',
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: '#666',
                    fontSize: 11,
                    lineHeight: 18
                  },
                  formatter: function(params) {
                    return axisFormatter(params, xAxisData.length);
                  }
                }
              },
              yAxis: {
                name: '任务数（单）'
              },
              series: createLineSeries(series0data)
            }
          }
        ]
      }
    };
  },
  type4(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || [];
    // let header = [{ label: '答案', prop: 'd' }];
    let data = [];
    // let xAxisData = [];
    // let series0data = [];
    finalData.forEach(m => {
      data.push({
        d: m
      });
    });
    return {
      key: 'type4-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        customComponents: [
          {
            options: {
              series0data: data,
              finalDataCount: finalDataCount
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type5(im, ix) {
    let { type, title, finalDataCount, isMustFill, manyTitleJson, remark } = im;
    let finalData = im.finalData || [];
    let formatData = []; // 二维数组
    manyTitleJson = manyTitleJson
      ? manyTitleJson
          .replace(/\[\"|\"\]/g, '')
          .replace(/\"/g, '')
          .split(',')
      : [];
    finalData.forEach((item, index) => {
      item = item
        ? item
            .replace(/\[\"|\"\]/g, '')
            .replace(/\"/g, '')
            .split(',')
        : [];
      item.forEach((item2, index2) => {
        if (!formatData[index]) {
          formatData[index] = [item2];
        } else {
          formatData[index].push(item2);
        }
      });
    });
    let header = [];
    let data = [];
    // let xAxisData = [];
    // let series0data = [];
    manyTitleJson.forEach((item, index) => {
      header.push({
        label: item,
        prop: `d${index}`
      });
    });
    formatData.forEach(item => {
      let d = {};
      item.forEach((item2, index2) => {
        d[`d${index2}`] = item2;
      });
      data.push(d);
    });

    return {
      key: 'type5-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        customComponents: [
          {
            options: {
              isMultiple: true,
              header,
              series0data: data,
              finalDataCount: finalDataCount
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type6(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || {};
    let header = [
      { label: '评分', prop: 'd' },
      { label: '任务数（单）', prop: 'v' },
      { label: '百分比(%)', prop: 'b' }
    ];
    let data = [];
    let xAxisData = [];
    let series0data = [];
    let total = 0; // 总分
    Object.entries(finalData).forEach(m => {
      total += m[0] * m[1];
      xAxisData.push(m[0] + '分');
      series0data.push({
        value: m[1],
        name: m[0],
        b: m[1] + '单'
      });
      // header.push({
      //   label: m[0] + '分',
      //   prop: `d${m[0]}`
      // });
      // data[0]['d' + m[0]] = percentage(m[1], finalDataCount);
      data.push({
        d: m[0],
        v: m[1],
        b: percentage(m[1], finalDataCount)
      });
    });
    data.push({
      d: '平均分',
      v: percentage(total, finalDataCount, { multiple: 1, symbol: '' }),
      b: '-'
    });
    return getGradeOptions({
      ix,
      title,
      remark,
      questionType: questionMap[type],
      isMustFill,
      header,
      data,
      finalDataCount,
      xAxisData,
      series0data
    });
  },
  type7(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || [];

    // let header = [{ label: '答案', prop: 'd' }];
    let data = [];
    // let xAxisData = [];
    // let series0data = [];
    finalData.forEach(m => {
      data.push({
        d: m
      });
    });
    return {
      key: 'type7-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        customComponents: [
          {
            options: {
              series0data: data,
              finalDataCount: finalDataCount
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type14(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || [];
    // let header = [{ label: '答案', prop: 'd' }];
    let data = [];
    // let xAxisData = [];
    // let series0data = [];
    finalData.forEach(m => {
      data.push({
        d: m
      });
    });
    return {
      key: 'type14-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        customComponents: [
          {
            options: {
              series0data: data,
              finalDataCount: finalDataCount
            },
            com: require('../components/customCharts/fillBlanks').default
          }
        ]
      }
    };
  },
  type15(im, ix) {
    let { type, title, finalDataCount, isMustFill, remark } = im;
    let finalData = im.finalData || { year: [], month: [] };
    let year = finalData.year || {};
    let month = finalData.month || {};
    // let data = [];
    // let xAxisData = [];
    let series0data = [];
    Object.entries(year).forEach(m => {
      series0data.push({ value: m[1], name: m[0] + '年' });
    });
    let header = [{ label: '月份', prop: 'd' }];
    let monthData = [];
    let monthXAxisData = [];
    let monthSeries0data = [];
    let dv = { d: '任务数（单）' };
    let formatMonth = month.sort((a, b) => {
      return +Object.keys(a)[0] - Object.keys(b)[0];
    });
    Object.entries(formatMonth).forEach((m, i) => {
      let v = Object.values(m[1])[0];
      monthXAxisData.push(+m[0] + 1 + '月');
      monthSeries0data.push(v);
      header.push({ label: +m[0] + 1 + '月', prop: `d${i}` });
      dv[`d${i}`] = v;
    });
    monthData.push(dv);
    return {
      key: 'type15-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        table: { header, data: monthData, finalDataCount, isNormal: true },
        echart: [
          {
            echartType: 'line',
            echartOption: {
              tooltip: {
                formatter: function(params) {
                  const { axisValue, value } = params[0] || params || {};
                  return dealTips(axisValue, value, '单');
                }
              },
              xAxis: {
                type: 'category',
                name: '月份',
                axisLabel: {
                  interval: 0
                },
                data: monthXAxisData
              },
              yAxis: {
                name: '任务数（单）'
              },
              series: createLineSeries(monthSeries0data)
            }
          }
        ]
      }
    };
  },
  type16(im, ix) {
    let { type, title, finalData, isMustFill, remark } = im;
    return {
      key: 'querytaskHospitalDistribution',
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: title,
          remark,
          isMustFill
        },
        useMapLayout: false,
        echart: [
          {
            echartType: 'map',
            echartStyle: { height: '500px' },
            echartOption: {
              series: createMapSeries1(finalData)
            }
          }
        ]
      }
    };
  },
  type20(im, ix) {
    let { type, title, finalDataCount, isMustFill } = im;
    let finalData = im.finalData || [];
    let data = [];
    finalData.forEach(m => {
      data.push({
        d: m
      });
    });
    return {
      key: 'type20-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionMap[type]})`,
          name: '',
          remark: '具体答案详情请查看附件',
          isMustFill,
          hideNoMore: true
        },
        customComponents: [
          {
            options: {
              series0data: data,
              finalDataCount: finalDataCount
            }
          }
        ]
      }
    };
  }
};

export default {
  query: {},
  // 上部分
  ...combination,
  // 问卷题型，该内容类型较多
  // 1单选  2多选  3单项投票  4单项填空 5多项填空 6打分题  7姓名手机邮箱-单选填空 8上传附件
  // 9 pdf 10 word 11 excel 12 ppt 13 jpg/png 14时间-单选填空 15月度--按年月分开做两张报表 16定位
  queryQuestionnaireDetailInfo() {
    return new Promise(async resolve => {
      let {
        data: { data }
      } = await BI[this.query.serviceType].queryQuestionnaireDetailInfo(
        this.query
      );
      let combination = [];
      data.forEach((item, index) => {
        if (typeFuncs[`type${item.type}`]) {
          combination.push(typeFuncs['type' + item.type](item, index + 1));
          // if (
          //   item.isMultiple == 1 ||
          //   item.finalDataCount > 0 ||
          //   item.type == 17
          // ) {
          //   // 必填题 || 答案数量大于0 || 描述题
          // }d
        }
      });
      resolve(combination);
    });
  },
  async run(query) {
    this.query = query;
    let arr = [];
    for (let i in this) {
      if (
        this.hasOwnProperty(i) &&
        i !== 'run' &&
        typeof this[i] === 'function'
      ) {
        arr.push(this[i]());
      }
    }
    return new Promise((resolve, reject) => {
      Promise.all(arr)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};
